import React from 'react';
import { useParams } from 'react-router-dom';
import RelocationWorkspace from '../../components/crm/RelocationWorkspace';

const RelocationWorkspacePage = () => {
    const { clientId } = useParams();
    return <RelocationWorkspace clientId={clientId} />;
};

export default RelocationWorkspacePage;
